export async function getInitialProps({context: {domain}, routeInfo: {location}}) {
  const {pathname: path} = location

  const getAuthenticationToken = domain.get('get_authentication_token_notifications_use_case').execute()

  const getPageName = await domain.get('get_page_name_page_use_case').execute({path})

  const [
    {value: authenticationToken},
    {
      value: {pageName}
    }
  ] = await Promise.allSettled([getAuthenticationToken, getPageName])

  const getPageTrackingData = domain.get('get_page_tracking_data_use_case').execute({page: pageName})

  const [{value: pageTrackingData}] = await Promise.allSettled([getPageTrackingData])

  return {
    authToken: authenticationToken,
    pageName,
    pageTrackingData
  }
}
